export const environment = {
  url: {
    api: `https://apim-dev.houseofhr.com/square-app-tmi/api/v2.0`,
  },
  production: false,
  ocpApimSubscriptionKey: '122a5aa9bfa44bc28d1cf136ca2220ae'
};

